<template>
  <div class="captcha">
    <div class="title">
      <p class="on">登录</p>
      <p @click="setMode">注册</p>
    </div>
    <div class="con">
      <div class="top">
        <el-input
          placeholder="请输入手机号"
          v-model="input1"
          class="input-with-select"
        >
          <el-select v-model="select" slot="prepend" placeholder="请选择">
            <el-option label="+86" value="1"></el-option>
            <el-option label="+85" value="2"></el-option>
            <el-option label="+81" value="3"></el-option>
          </el-select>
        </el-input>
        <el-input placeholder="请输入密码" v-model="input" show-password>
          <template slot="append">
            <button
              @click="getPhoneCode"
              :disabled="disabled"
              v-if="isGetCodeFlag"
            >
              获取验证码
            </button>
            <button disabled v-else>{{ initialNum }}s</button>
          </template>
        </el-input>
      </div>
      <div class="info">
        <a href="javascript:;" @click="setLoginMode">密码登录</a>
      </div>
      <button class="btn" @click="login">登录</button>
      <div class="text">
        <Agreement></Agreement>
      </div>
    </div>
  </div>
</template>

<script>
import Agreement from '@/components/login/agreement/agreement.vue'
import service from './captcha.js'

export default {
  name: 'captcha',
  data () {
    return {
      isHideFun: 'true',
      input1: '',
      select: '1',
      input: '',
      // 是否是正确的手机号
      disabled: true,
      // 判断是否已经获取了验证码
      isGetCodeFlag: true,
      // 点击获取验证码之后的读秒
      initialNum: 60,
      // 存放定时器
      timer: null
    }
  },
  components: {
    Agreement
  },
  created () {
  },
  computed: {
    system () {
      return this.$store.state.getsystem.system
    }
  },
  watch: {
    input1 (newV, oldV) {
      if (!(/^1[3456789]\d{9}$/.test(newV))) {
        this.disabled = true
      } else {
        this.disabled = false
      }
    }
  },
  methods: {
    BatchesFun (e) {
      this.isHideFun = e
    },
    getPhoneCode () {
      service.getPhoneCode(this, this.input1, 1)
      if (this.isGetCodeFlag) {
        this.isGetCodeFlag = false
        this.timer = setInterval(() => {
          if (this.initialNum <= 0) {
            this.isGetCodeFlag = true
            clearInterval(this.timer)
            this.timer = null
            this.initialNum = 60
          } else {
            this.initialNum -= 1
          }
        }, 1000)
      }
    },
    login () {
      service.phoneCodeLogin(this, this.input1, this.input)
    },
    // 改变登录模式
    setLoginMode () {
      this.$store.dispatch('set_isPassLogin', true)
    },
    // 改变登录注册模式
    setMode () {
      this.$store.dispatch('set_isLogin', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./captcha";
</style>



// WEBPACK FOOTER //
// src/components/login/captcha/captcha.vue